let stripeScriptPromise = null;

export function loadStripeJs() {
  if (typeof window !== "undefined" && window.Stripe) {
    return Promise.resolve(window.Stripe);
  }
  if (stripeScriptPromise) {
    return stripeScriptPromise;
  }
  stripeScriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src="https://js.stripe.com/v3/"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(window.Stripe));
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/";
    script.async = true;
    script.onload = () => resolve(window.Stripe);
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return stripeScriptPromise;
}

/**
 * Mount Stripe Embedded Checkout (card form inside our modal).
 * @returns {Promise<{ destroy: Function }>}
 */
export async function mountEmbeddedCheckout({
  publishableKey,
  clientSecret,
  container,
}) {
  const Stripe = await loadStripeJs();
  const stripe = Stripe(publishableKey);
  const checkout = await stripe.initEmbeddedCheckout({ clientSecret });
  checkout.mount(container);
  return checkout;
}

/**
 * Redirect to Stripe-hosted checkout (fallback).
 */
export async function redirectToStripeCheckout({ publishableKey, sessionId, checkoutUrl }) {
  if (checkoutUrl) {
    window.location.href = checkoutUrl;
    return true;
  }
  if (!publishableKey || !sessionId) {
    return false;
  }
  const Stripe = await loadStripeJs();
  const stripe = Stripe(publishableKey);
  const { error } = await stripe.redirectToCheckout({ sessionId });
  if (error) {
    throw error;
  }
  return true;
}
